<template>
  <div class="m-header-search">
    <img src="@/assets/icon/search.svg" @click="toSearch">
    <input ref="refKeyword" :placeholder="$t('global.typeKeyword')" @keyup="onSearchKeyPress">
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
import { getAtModel } from '@/utils/atModel'

export default defineComponent({
  setup () {
    const router = useRouter()
    const refKeyword = ref()
    const toSearch = (e?: Event) => {
      getAtModel().doActionEvent(`main_menu::search::${refKeyword.value.value}`, e)
      router.push(`/mobile/search?keyword=${encodeURIComponent(refKeyword.value.value)}`)
    }
    const onSearchKeyPress = (e: KeyboardEvent) => {
      if (e.keyCode === 13) {
        e.preventDefault()
        toSearch(e)
      }
    }
    return {
      refKeyword,
      toSearch,
      onSearchKeyPress
    }
  }
})
</script>

<style lang="less">
  .m-header-search{
    width: 100%;
    border-bottom: 1px solid #EAEAEA;
    display: flex;
    align-items: center;
    padding: 0.6rem 0 0.6rem 0;
    font-size: 1.4rem;
    color: #999999;
    img {
      margin: 0 1.2rem 0 1.5rem;
    }
    input {
      border: none;
      background-color: transparent;
      outline: medium;
      height: 2rem;
      width: 100%;
    }
  }
</style>
